export const containerStyles = 'w-[390px] flex flex-col gap-4'
export const headerStyles = 'p-6 flex items-center gap-4 border-b'
export const headerTitleStyles = 'text-lg-semibold'
export const bodyStyles = 'px-6 py-4 flex flex-col gap-4'
export const footerStyles = 'p-6 flex items-center gap-3 border-t'
